<template>
  <GlobalWindow :title="title" :visible.sync="visible" :confirm-working="isWorking" @confirm="confirm">
    <el-form :model="form" ref="form" :rules="rules">
      <el-form-item label="名称" prop="templateName"><el-input v-model="form.templateName" placeholder="名称" /></el-form-item>
      <el-form-item label="类型" prop="templateType"><el-select v-model="form.templateType" placeholder="类型">
        <el-option label="日记模板" value="diary_write" />
        <el-option label="洞察模板" value="insight_detail" />
        <el-option label="手记模板" value="share_handnote" />
      </el-select></el-form-item>
      <el-form-item label="默认" prop="isDefault"><el-select v-model="form.isDefault" placeholder="默认">
        <el-option label="否" value="0" />
        <el-option label="是" value="1" />
      </el-select></el-form-item>
      <el-form-item label="启用" prop="isActive"><el-select v-model="form.isActive" placeholder="启用">
        <el-option label="启用" value="1" />
        <el-option label="禁用" value="0" />
      </el-select></el-form-item>
    </el-form>
  </GlobalWindow>
</template>
<script>
import BaseOpera from '@/components/base/BaseOpera'
import GlobalWindow from '@/components/common/GlobalWindow'
export default {
  name: 'operatemplateConfigWindow', extends: BaseOpera, components: { GlobalWindow },
  data() { return { form: { id: null, templateName: '', templateType: '', isDefault: '0', isActive: '1' }, rules: {} } },
  created() { this.config({ api: '/rentHouse/templateConfig', 'field.id': 'id' }) }
}
</script>